module.exports = __webpack_public_path__ + "img/1-1.dc9d5f16.png";